import {addYears, addDays, format, parse} from "date-fns";
import parseISO from "date-fns/parseISO";

export default class DateUtils {

  /**
   * Formats date string in format dd.MM.yyyy
   * to string in format yyy-MM-dd
   *
   * @param date
   * @returns {string|null}
   */
  static parseDateForVuetify(date) {
    if (!date) return null

    const [day, month, year] = date.split('.')
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  /**
   * Formats time string of format HH:mm:ss
   * to time string of format HH:mm
   *
   * @param time
   * @returns {string|null}
   */
  static parseTimeForVuetify(time) {
    if (!time) return null;
    const [hour, minute] = time.split(':');
    return `${hour}:${minute}`;
  }

  /**
   * Formats yyyy-MM-dd HH:mm:ss.SSS
   * to dd.MM.YYYY HH:mm:ss
   *
   * @param {String} date date to format
   * @param {String} dateFormat format how the date should be formatted
   * @returns {String} formatted date
   */
  static parseDateTimeForDisplay(date, dateFormat = process.env.VUE_APP_DATETIME_FORMAT) {
    if (!date) return null;
    return format(parseISO(date), dateFormat);
  }

  /**
   * Turns a dateTime String of Format yyyy-MM-dd HH:mm:ss.SSS
   * to a date object for further processing
   *
   * @param {String} dateTime
   * @returns given dateTime as date object
   */
  static parseDateTimeStringToDateObject(dateTime) {
    if(!dateTime) return null;

    var date = dateTime.split(' ')[0];
    var time = dateTime.split(' ')[1].split('.')[0]

    return new Date(date + ' ' + time);
  }

  /**
   * Returns current Date and Time in
   * yyyy-MM-dd HH:mm:ss.SS format
   *
   * @returns {String}
   */
  static getCurrentDateTime() {
    const date = new Date().toISOString().substr(0, 10)
    const time = new Date().toLocaleTimeString('UTC');
    const now = date + " " + time + ".000";

    return now;
  }

  /**
   * Returns current date as pretty date string in german format dd.mm.yyyy
   *
   * @returns current date as german date string
   */
  static getCurrentDateAsDEString() {
    const date = new Date();
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var dateDEString;

    if(day < 10) {
      if(month < 10) {
        dateDEString = '0' + day + '.' + '0' + month + '.' + date.getFullYear();
      } else {
        dateDEString = '0' + day + '.' + month + '.' + date.getFullYear();
      }
    } else {
      if(month < 10) {
        dateDEString = day + '.' + '0' + month + '.' + date.getFullYear();
      } else {
        dateDEString = day + '.' + month + '.' + date.getFullYear();
      }
    }

    return dateDEString;
  }

  /**
   * Add specific years to a date
   *
   * @param date date to add years to
   * @param years years which should be added to the date
   * @returns {string} calculated date
   */
  static addYearsToDate(date, years) {
    const result = addYears(parse(date, "dd.MM.yyyy", new Date()), years);
    return format(result, "dd.MM.yyyy");
  }
  /**
   * Add specific days to a date
   *
   * @param date date-string in format dd.MM.yyyy to add days to
   * @param days days which should be added to the date
   * @returns {string} calculated date-string in format dd.MM.yyyy
   */
  static addDaysToDate(date, days) {
    const result = addDays(parse(date, "dd.MM.yyyy", new Date()), days);
    return format(result, "dd.MM.yyyy");
  }

  /**
   * Parse string by providing format and return a Date object
   *
   * @param date
   * @param format
   * @returns {Date}
   */
  static parseStringToDate(date, format = process.env.VUE_APP_DATE_FORMAT_DTO) {
    if (!date) return null;
    return parse(date, format, new Date());
  }
}